import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  company_icon,
  company_role,
  device_act,
  device_icon,
  location_act,
  location_icon,
  logo,
  logout_icon,
  user_act,
  user_icon,
} from "../assets/imgs";

import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import apiRequest from "../screens/redux/api/apiRequest";
import { useLazyCompanyLogoutQuery, useLazyLogoutQuery } from "../screens/redux/api/api";
import { toast } from "react-toastify";
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';

const SideBarCompany = ({ setSaidList }) => {
  // All Dropdowns
  const [roles, setRoles] = useState(null);
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [locationlist, setLocationlist] = useState([]);
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [popup, setPopup] = useState();
  const [profileDrop, setProfileDrop] = useState();
  const [logout] = useLazyCompanyLogoutQuery();

  const handleLogout = async () => {
    const res = await apiRequest(logout);
    if (res?.status == "success") {
      localStorage.clear();
      navigate("/");
      toast.success(res?.message);
    }
    // console.log(res);
    setPopup(false);
  };

  const toggle_nav = () => {
    setSaidBarShow(!saideBarShow);
  };

  const profileDropDown = () => {
    setProfileDrop(true);
  }
  const onClose = () => {
    setProfileDrop(false);
  }



  // const company = localStorage.getItem("company");
  // console.log("comp", company);
  const loginType = localStorage.getItem("type")

  const company = JSON.parse(localStorage.getItem("company"))
  const companyName = company?.name

  return (
    <div className={`${saideBarShow ? " sidebar" : "close_sidebar  "} `}>
      <div
        onClick={() => {
          toggle_nav();
        }}
        className=""
      >
        {saideBarShow ? (
          <KeyboardDoubleArrowRightIcon className="arrow-right" />
        ) : (
          ""
        )}
      </div>
      <div
        onClick={() => {
          toggle_nav();
        }}
        className=""
      >
        {saideBarShow ? (
          ""
        ) : (
          <KeyboardDoubleArrowLeftIcon className="arrow-left" />
        )}
      </div>

      <div className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            <li
              className="nav_link trans"
              onClick={() => {
                navigate(companyName + "/manager");
                onClose();
              }}
            >
              <h4
                className={` ${splitLocation[2] === "manager"
                  ? " f3 active_bar"
                  : " "
                  } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
              >
                {console.log("pathh", splitLocation)}
                {splitLocation[2] === "manager" ? (
                  <img src={user_act} className="icon " alt="" />
                ) : (
                  <img src={user_icon} className="icon " alt="" />
                )}
                <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                  {loginType == "Company Sub Admin" ? "SubAdmin" : loginType == "Company User" ? "User" : "Manager"}
                </span>
              </h4>
            </li>
            {givenpermissions?.includes("COMPANY-CAN-List-COMPANY_ROLES") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate(companyName + "/role");
                  onClose();
                }}
              >
                <h4
                  className={` ${splitLocation[2] === "role" ||
                    splitLocation[2] === "add-company-role"
                    ? " f3 active_bar"
                    : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  {splitLocation[2] === "role" ||
                    splitLocation[2] === "add-company-role" ? (
                    <img src={user_act} className="icon " alt="" />
                  ) : (
                    <img src={user_icon} className="icon " alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                    Role
                  </span>
                </h4>
              </li>
            )}
            {givenpermissions?.includes("COMPANY-CAN-List-COMPANY_USERS") && loginType != "Company User" && (
              <li
                className="nav_link trans"
                onClick={() => {
                  profileDropDown();
                }}
              >
                <h4
                  className={`ps-4 ${splitLocation[2] === "sub-admin" || splitLocation[2] === "users" ? " f3 active_bar"
                    : " "}  f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  {splitLocation[2] === "sub-admin" ||
                    splitLocation[2] === "users" ? (
                    <img src={user_act} className="icon " alt="" />
                  ) : (
                    <img src={user_icon} className="icon " alt="" />
                  )}
                  <span className="text ps-1 text-nowrap">Profile </span>
                </h4>
              </li>
            )}
            {profileDrop && (
              <ul>
                {loginType != "Company Sub Admin" && (
                  <li
                    className="nav_sub_link trans"
                    onClick={() => navigate(companyName + "/sub-admin")}
                  >
                    <h4
                      className={`ps-4 sub-menu  ${splitLocation[2] === "sub-admin" ? " f3 active_bar"
                        : " "} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18`}
                    >
                      <span className="text ps-1 ">Sub Admin </span>
                    </h4>
                  </li>
                )}
                <li
                  className="nav_sub_link trans"
                  onClick={() => navigate(companyName + "/users")}
                >
                  <h4
                    className={`ps-4 sub-menu  ${splitLocation[2] === "users" ? " f3 active_bar"
                      : " "} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18`}
                  >
                    <span className="text ps-1 ">Members</span>
                  </h4>
                </li>
              </ul>
            )}
            {givenpermissions?.includes("COMPANY-CAN-List-COMPANY_DEVICES") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate(companyName + "/device-list");
                }}
              >
                <h4
                  className={` ${splitLocation[2] === "device-add" ||
                    splitLocation[2] === "report-list" ||
                    splitLocation[2] === "members-list" ||
                    splitLocation[2] === "notification-report-list" ||
                    splitLocation[2] === "device-list"
                    ? " f3 active_bar"
                    : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  {splitLocation[2] === "device-add" ||
                    splitLocation[2] === "report-list" ||
                    splitLocation[2] === "members-list" ||
                    splitLocation[2] === "notification-report-list" ||
                    splitLocation[2] === "device-list" ? (
                    <img src={device_act} className="icon " alt="" />
                  ) : (
                    <img src={device_icon} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                    Device List
                  </span>
                </h4>
              </li>
            )}
            {givenpermissions?.includes("COMPANY-CAN-List-COMPANY_LOCATIONS") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate(companyName + "/location-marks");
                }}
              >
                <h4
                  className={` ${splitLocation[2] === "location-marks"
                    ? " f3 active_bar"
                    : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  {splitLocation[2] === "location-marks" ? (
                    <img src={location_act} className="icon " alt="" />
                  ) : (
                    <img src={location_icon} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                    Location Marks
                  </span>
                </h4>
              </li>
            )}
            {givenpermissions?.includes("COMPANY-CAN-List-COMPANY_LOGS") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate(companyName + "/daily-log");
                }}
              >
                <h4
                  className={` ${splitLocation[2] === "daily-log"
                    ? " f3 active_bar"
                    : " "
                    } ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 `}
                >
                  {splitLocation[2] === "daily-log" ? (
                    <DatasetLinkedIcon />
                  ) : (
                    <DatasetLinkedIcon />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ps-1">
                    Daily Log Report
                  </span>
                </h4>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div
        className="d-flex ac-je pt-2 pe-2 pointer"
        onClick={() => setPopup(true)}
      >
        <img src={logout_icon} className="icon " alt="" />
        <h4 className=" f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
          Logout
        </h4>
      </div>
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary mt-4">
              Logout
            </h2>
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Logout?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  handleLogout();

                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SideBarCompany;
